import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const linkPlugin = createPluginFromSingleComponentPlugin({
    name: 'LinkPlugin',
    components: new Set([
        'MenuButton',
        'wixapps.integration.components.ImageButton',
        'RSSButton',
        'wysiwyg.common.components.imagebutton.viewer.ImageButton',
        'SubscribeForm',
        'AdminLoginButton',
        'ContactForm',
        'DynamicContactForm',
        'FlashComponent',
        'SiteButton',
        'QuickActionBarItem',
        'ExitMobileMode',
        'SvgShape',
        'VectorImage',
        'PopupCloseTextButton',
        'PopupCloseIconButton',
        'wysiwyg.viewer.components.BackToTopButton',
        'Logo',
        'CollapsibleText',
        'HamburgerCloseButton',
        'HamburgerOpenButton',
        'ImageX',
        'SlideshowButton',
        'StylableButton',
        'TextMask',
        'ControlTypes',
        'DashboardButton',
        'DashboardIconButton',
        'DashboardTextButton',
        'WPhoto',
        'WbuRichText'
    ]),
    pack,
    unpack
})
